import React from "react";

const InsightIcon = () => (
  <svg id="Insight_icon" data-name="Insight Icon" xmlns="http://www.w3.org/2000/svg" width="15.78" height="18.228" viewBox="0 0 15.78 18.228">
    <g id="Infographic" transform="translate(0.377 0.377)">
      <g id="Inforgraphic_01" data-name="Inforgraphic 01">
        <g id="Bars" transform="translate(2.82 4.99)">
          <rect id="Rectangle_6166" data-name="Rectangle 6166" width="1.13" height="10.362" fill="#969696" />
          <rect id="Rectangle_6167" data-name="Rectangle 6167" width="1.13" height="6.831" transform="translate(2.708 3.53)" fill="#969696" />
          <rect id="Rectangle_6168" data-name="Rectangle 6168" width="1.13" height="2.904" transform="translate(5.417 7.458)" fill="#969696" />
        </g>
        <path
          id="Box"
          d="M12.562,2.482V.375H.375V17.85H12.562V9.794"
          transform="translate(-0.375 -0.375)"
          fill="none"
          stroke="#969696"
          strokeMiterlimit="10"
          strokeWidth="0.754"
        />
      </g>
      <path
        id="Search"
        d="M15.7,9.421l-.179.13a3.189,3.189,0,0,1-1.817.583A3.131,3.131,0,1,1,16.833,7a3.369,3.369,0,0,1-.574,1.853l-.124.179,1.889,1.883-.408.408Zm-2-5.027A2.609,2.609,0,1,0,16.31,7,2.613,2.613,0,0,0,13.7,4.393Z"
        transform="translate(-2.887 -1.236)"
        fill="#969696"
        stroke="#969696"
        strokeMiterlimit="10"
        strokeWidth="0.377"
      />
    </g>
  </svg>
);

export default InsightIcon;
